import {
  MoreHorizontal,
  Pencil,
  Trash2,
  Eye,
  ClipboardList,
} from "lucide-react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@repo/ui";

interface TransactionRowActionsProps<T> {
  record: T;
  onView: (record: T) => void;
  onEdit?: (record: T) => void;
  onDelete?: (record: T) => void;
  onAddToReminder?: (record: T) => void;
}

export function TransactionRowActions<T>({
  record,
  onView,
  onEdit,
  onDelete,
  onAddToReminder,
}: TransactionRowActionsProps<T>) {
  const hasMutationActions = onEdit || onDelete || onAddToReminder;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onView(record)}>
          <Eye className="mr-2 h-4 w-4" />
          View Details
        </DropdownMenuItem>
        {hasMutationActions && <DropdownMenuSeparator />}
        {onEdit && (
          <DropdownMenuItem onClick={() => onEdit(record)}>
            <Pencil className="mr-2 h-4 w-4" />
            Edit
          </DropdownMenuItem>
        )}
        {onAddToReminder && (
          <DropdownMenuItem onClick={() => onAddToReminder(record)}>
            <ClipboardList className="mr-2 h-4 w-4" />
            Add to Reminders
          </DropdownMenuItem>
        )}
        {onDelete && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => onDelete(record)}
              className="text-destructive focus:text-destructive"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
